var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLegalStepsImg7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_108_894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.0418 45.0417C43.5643 44.9874 42.1155 44.6172 40.793 43.956C39.4706 43.2948 38.3051 42.3579 37.3752 41.2084C36.7022 42.389 35.7247 43.3675 34.5448 44.0417C33.3649 44.7159 32.0257 45.0613 30.6668 45.0417C29.1957 44.9564 27.7573 44.5726 26.4392 43.9136C25.1212 43.2546 23.9511 42.3341 23.0002 41.2084C22.308 42.372 21.3263 43.3367 20.1508 44.0084C18.9752 44.6802 17.6458 45.0361 16.2918 45.0417C13.3294 44.8299 10.572 43.4513 8.62516 41.2084C7.81661 42.4841 6.67549 43.5151 5.32459 44.1906C3.9737 44.866 2.46418 45.1603 0.958496 45.0417",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0418 39.2917C43.5643 39.2374 42.1155 38.8672 40.793 38.206C39.4706 37.5448 38.3051 36.6079 37.3752 35.4584C36.7022 36.639 35.7247 37.6175 34.5448 38.2917C33.3649 38.9659 32.0257 39.3113 30.6668 39.2917C29.1957 39.2064 27.7573 38.8226 26.4392 38.1636C25.1212 37.5046 23.9511 36.5841 23.0002 35.4584C22.308 36.622 21.3263 37.5867 20.1508 38.2584C18.9752 38.9302 17.6458 39.2861 16.2918 39.2917C13.3294 39.0799 10.572 37.7013 8.62516 35.4584C7.81661 36.7341 6.67549 37.7651 5.32459 38.4406C3.9737 39.116 2.46418 39.4103 0.958496 39.2917",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.375 23.9583L22.2582 14.3232C22.3481 14.2133 22.4613 14.1248 22.5896 14.064C22.7179 14.0032 22.858 13.9717 23 13.9717C23.142 13.9717 23.2821 14.0032 23.4104 14.064C23.5387 14.1248 23.6519 14.2133 23.7417 14.3232L31.625 23.9583",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4168 38.732L6.47655 25.3575C6.40087 25.2115 6.36407 25.0483 6.3697 24.8839C6.37533 24.7195 6.4232 24.5593 6.50869 24.4187C6.59419 24.2781 6.71443 24.162 6.85785 24.0813C7.00127 24.0007 7.16303 23.9584 7.32755 23.9584H38.6842C38.8483 23.9582 39.0096 24.0002 39.1528 24.0802C39.296 24.1603 39.4163 24.2757 39.502 24.4156C39.5878 24.5554 39.6363 24.7149 39.6428 24.8789C39.6492 25.0428 39.6135 25.2056 39.539 25.3518L32.5835 38.9716",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4165 38.732L22.9998 23.9584L32.5832 38.9716",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2083 5.75002H40.25C40.2406 4.63459 39.8423 3.5574 39.1238 2.70415C38.4053 1.8509 37.4116 1.27507 36.314 1.0759C35.2165 0.876742 34.0838 1.06674 33.1114 1.61314C32.1389 2.15954 31.3875 3.0281 30.9867 4.0691C30.5774 3.91731 30.1449 3.83755 29.7083 3.83335C28.6917 3.83335 27.7166 4.23722 26.9978 4.95611C26.2789 5.675 25.875 6.65002 25.875 7.66668C25.875 8.68335 26.2789 9.65837 26.9978 10.3773C27.7166 11.0962 28.6917 11.5 29.7083 11.5H41.2083C41.9708 11.5 42.7021 11.1971 43.2413 10.658C43.7804 10.1188 44.0833 9.38752 44.0833 8.62502C44.0833 7.86252 43.7804 7.13125 43.2413 6.59209C42.7021 6.05292 41.9708 5.75002 41.2083 5.75002Z",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_108_894"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalStepsImg7);
export default __webpack_public_path__ + "static/media/legalStepsImg7.5595f6f622d0d3c6ed8c814b6a21f4dc.svg";
export { ForwardRef as ReactComponent };